/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SearchVectorStoreRequest = {
  vectorStoreId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  searchVectorStoreRequest: components.SearchVectorStoreRequest;
};

/** @internal */
export const SearchVectorStoreRequest$inboundSchema: z.ZodType<
  SearchVectorStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  vector_store_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  SearchVectorStoreRequest: components.SearchVectorStoreRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "vector_store_id": "vectorStoreId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "SearchVectorStoreRequest": "searchVectorStoreRequest",
  });
});
/** @internal */
export type SearchVectorStoreRequest$Outbound = {
  vector_store_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  SearchVectorStoreRequest: components.SearchVectorStoreRequest$Outbound;
};

/** @internal */
export const SearchVectorStoreRequest$outboundSchema: z.ZodType<
  SearchVectorStoreRequest$Outbound,
  z.ZodTypeDef,
  SearchVectorStoreRequest
> = z.object({
  vectorStoreId: z.string(),
  xOnBehalfOf: z.string().optional(),
  searchVectorStoreRequest: components.SearchVectorStoreRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    vectorStoreId: "vector_store_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    searchVectorStoreRequest: "SearchVectorStoreRequest",
  });
});

export function searchVectorStoreRequestToJSON(
  searchVectorStoreRequest: SearchVectorStoreRequest,
): string {
  return JSON.stringify(
    SearchVectorStoreRequest$outboundSchema.parse(searchVectorStoreRequest),
  );
}
export function searchVectorStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<SearchVectorStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchVectorStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchVectorStoreRequest' from JSON`,
  );
}
